import { useEffect, useState } from "react";
import { Box, Paper, Typography, MenuItem, Select, Button, Alert } from "@mui/material";
import { listIndustries } from "../services/catalog";
import { updateIndustry } from "../services/shops";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function ChooseIndustryPage() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [industries, setIndustries] = useState<Array<{ key: string; name: string }>>([]);
  const [industryKey, setIndustryKey] = useState("electronics");
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try { setIndustries(await listIndustries()); } catch { setIndustries([{ key: 'electronics', name: 'Electronics Repair' }]); }
    })();
  }, []);

  const save = async () => {
    if (!token) return;
    try {
      setSaving(true); setError(null);
      await updateIndustry(token, industryKey);
      navigate("/");
    } catch (e: any) {
      setError(e?.response?.data?.message || "Failed to update industry");
    } finally { setSaving(false); }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2 }}>
      <Paper elevation={2} sx={{ p: 3, borderRadius: 3, width: '100%', maxWidth: 520 }}>
        <Typography variant="h5" fontWeight={900} gutterBottom>Choose Your Industry</Typography>
        <Typography color="text.secondary" sx={{ mb: 2 }}>We’ll tailor menus and defaults for your business.</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Select fullWidth size="small" value={industryKey} onChange={(e)=>setIndustryKey(String(e.target.value))} sx={{ mb: 2 }}>
          {industries.map((i)=> <MenuItem key={i.key} value={i.key}>{i.name}</MenuItem>)}
        </Select>
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          <Button variant="outlined" onClick={()=>navigate('/')} disabled={saving}>Skip</Button>
          <Button variant="contained" onClick={save} disabled={saving}>{saving ? 'Saving…' : 'Save'}</Button>
        </Box>
      </Paper>
    </Box>
  );
}

